






















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import EmailService from '@/shared/services/EmailService';
import Notify from '@/shared/services/Notify/Notify';
import { Busy } from './Busy';

@Component
export default class FooterOne extends Vue {

private isBusy: boolean = false;
private fromEmailAddress: string = '';
private subject: string = '';
private message: string = '';

private async handleSubmit(event: any) {

  this.isBusy = true;
  event.preventDefault();
  try {
    const message = { fromEmailAddress: this.fromEmailAddress, subject: this.subject, message: this.message};
    await EmailService.sendContactMessage(message);
    this.resetForm();
    Notify.success('Wiadomość została pomyślnie wysłana.');
  } catch {
    Notify.error('Wystąpił nieoczekiwany błąd.');
  } finally {
    this.isBusy = false;
  }
}


private resetForm() {
    this.fromEmailAddress = '';
    this.subject = '';
    this.message = '';
    this.isBusy = false;
  }

}
